var map = {
	"./appsgoogle_gmail.svg": 32941,
	"./appsgoogle_maps.svg": 15684,
	"./appsgoogle_youtube.svg": 10876,
	"./arrow_merge.svg": 91199,
	"./bullet_black.png": 46444,
	"./bullet_blue.png": 73861,
	"./bullet_green.png": 23548,
	"./bullet_orange.png": 8207,
	"./bullet_pink.png": 81945,
	"./bullet_purple.png": 85411,
	"./bullet_red.png": 32904,
	"./chart_curve.svg": 33281,
	"./chart_line.svg": 94142,
	"./chart_organisation.svg": 9414,
	"./chart_pie.svg": 13966,
	"./close.svg": 38909,
	"./conn_connect.png": 36065,
	"./conn_disconnect.png": 18517,
	"./flag_blue.svg": 94112,
	"./flag_green.svg": 21829,
	"./flag_orange.svg": 12578,
	"./flag_pink.svg": 84960,
	"./flag_purple.svg": 46938,
	"./flag_yellow.svg": 54572,
	"./hard_drive_cd.svg": 84565,
	"./hard_ipod.svg": 81005,
	"./hard_skull.svg": 55726,
	"./links.svg": 89230,
	"./meetapps_facebook-messenger.svg": 62623,
	"./meetapps_google-meet.svg": 86868,
	"./meetapps_ms-teams.svg": 46936,
	"./meetapps_slack.svg": 70767,
	"./meetapps_whatapp.svg": 97120,
	"./meetapps_zoom.svg": 26292,
	"./money_dollar.svg": 47694,
	"./money_ruby.svg": 41092,
	"./notes.svg": 58138,
	"./object_music.svg": 89770,
	"./onoff_add.svg": 14411,
	"./onoff_delete.svg": 24559,
	"./onoff_status_offline.png": 85467,
	"./onoff_status_offline.svg": 31068,
	"./onoff_status_online.png": 72261,
	"./onoff_status_online.svg": 15802,
	"./sign_cancel.svg": 19089,
	"./sign_closed.svg": 26359,
	"./sign_exclamation.svg": 16922,
	"./sign_help.svg": 5582,
	"./sign_info.svg": 75143,
	"./sign_warning.svg": 66677,
	"./social_facebook.svg": 44733,
	"./social_google-plus.svg": 67389,
	"./social_instagram.svg": 34711,
	"./social_redit.svg": 49997,
	"./social_twitter.svg": 67802,
	"./soft_cursor.svg": 86528,
	"./soft_database.svg": 34845,
	"./soft_database_table.svg": 75092,
	"./soft_feed.svg": 22854,
	"./soft_folder_explore.svg": 14414,
	"./soft_penguin.svg": 2342,
	"./soft_rss.svg": 32218,
	"./tag_blue.svg": 58436,
	"./tag_green.svg": 24553,
	"./tag_orange.svg": 63038,
	"./tag_pink.svg": 10004,
	"./tag_purple.svg": 51374,
	"./tag_red.svg": 68397,
	"./tag_white.svg": 96783,
	"./tag_yellow.svg": 45264,
	"./task_0.svg": 22309,
	"./task_100.svg": 356,
	"./task_25.svg": 79448,
	"./task_50.svg": 89112,
	"./task_75.svg": 49099,
	"./things_address_book.svg": 93027,
	"./things_bubbles.svg": 50420,
	"./things_skull.svg": 48550,
	"./things_window-layout.svg": 66482,
	"./things_wrench.svg": 13844,
	"./time_calendar.svg": 58797,
	"./time_clock.svg": 20215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96617;